import React, { useCallback, useEffect, useState } from 'react';
import classNames                                  from 'classnames';

import './scss/style.scss';

import FooterAccordionArrowIcon from '../../../../../icons/FooterAccordionArrowIcon';
import FooterNavigationItem     from '../FooterNavigationItem';

function FooterNavigationSection(props) {
  const {
          items,
          label,
        } = props;

  const [open, setOpen]         = useState(true);
  const [isMobile, setIsMobile] = useState(true);

  const changeState = useCallback(() => {
    if (window.innerWidth < 1152) {
      setOpen(prevState => !prevState);
    }
  }, []);

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth < 1152);
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={classNames('nav-section', { open: isMobile && open })}>
      <div
        className={'category'}
        onClick={changeState}
      >{label}
        {isMobile && (
          <hr />)}
        {isMobile && (
          <FooterAccordionArrowIcon />)}
      </div>
      <ul>
        {items?.map((item, itemIndex) => (
          <FooterNavigationItem key={itemIndex} {...item} />
        ))}
      </ul>
    </div>
  );
}

export default FooterNavigationSection;